<img
    class="img--bg"
    src="assets/images/banners/background-home.webp"
    alt="img"
/>

<section class="section error">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-xl-6">
                <div class="align-container">
                    <div class="align-container__item">
                        <h1 class="error__title">404</h1>
                        <h2
                            class="error__subtitle"
                            translate="not-found-page.title"
                        ></h2>
                        <h3
                            class="error__text"
                            translate="not-found-page.text"
                        ></h3>
                        <a
                            class="button button--filled"
                            routerLink="/"
                            translate="not-found-page.home-button"
                        ></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
